import { FunctionComponent, useEffect } from 'react';
import { EbdsModalSheet } from '../components';
import { dxfStyleFix } from '../context/dxfIntegrationContext';
import { CorporateInformationPage } from './corporate-information/CorporateInformationPage';
import { DataActServicesPage } from './data-act/DataActServicesPage.tsx';
import { DataProcessingAgreementPage } from './data-processing-agreement/DataProcessingAgreementPage';
import { DataProtectionPolicyPage } from './data-protection-policy/DataProtectionPolicyPage';
import { DataProtectionPolicyPsPage } from './data-protection-policy/DataProtectionPolicyPsPage';
import { DataProtectionPolicyTwPage } from './data-protection-policy/DataProtectionPolicyTwPage';
import { DataProtectionPolicyUsPage } from './data-protection-policy/DataProtectionPolicyUsPage';
import { TermsOfUseForDealersSubPortal } from './terms-of-use-for-dealers-sub-portal/TermsOfUseForDealersSubPortal';
import { TermsOfUseForManufacturerServicesPage } from './terms-of-use-for-manufacturer-services/TermsOfUseForManufacturerServicesPage';
import { TermsOfUseForSubusersPage } from './terms-of-use-for-subusers/TermsOfUseForSubusersPage';
import { TermsOfUseAuPage } from './terms-of-use/TermsOfUseAuPage';
import { TermsOfUseRouterPage } from './terms-of-use/TermsOfUseRouterPage';
import { TermsOfUseUsPage } from './terms-of-use/TermsOfUseUsPage';
import { ThirdPartyLicensesPage } from './third-party-licenses/ThirdPartyLicensesPage';

interface DocPageMap {
  [key: string]: JSX.Element;
}

export const IndexPage: FunctionComponent = () => {
  const docName = document.getElementsByTagName('terms-of-use-app')[0]?.getAttribute('data-doc');

  const docPageMap: DocPageMap = {
    /* docName: LegalPageType */
    'corporate-information': <CorporateInformationPage />,
    'data-processing-agreement': <DataProcessingAgreementPage />,
    'data-protection-policy': <DataProtectionPolicyPage />,
    'data-protection-policy-us': <DataProtectionPolicyUsPage />, // deprecated
    'data-protection-policy-tw': <DataProtectionPolicyTwPage />, // deprecated
    'data-protection-policy-ps': <DataProtectionPolicyPsPage />,
    'third-party-licenses': <ThirdPartyLicensesPage />,
    'terms-of-use': <TermsOfUseRouterPage />,
    'terms-of-use-au': <TermsOfUseAuPage />, // deprecated
    'terms-of-use-us': <TermsOfUseUsPage />, // deprecated
    'terms-of-use-for-dealers-sub-portal': <TermsOfUseForDealersSubPortal />,
    'terms-of-use-for-sub-users': <TermsOfUseForSubusersPage />,
    'terms-of-use-for-manufacturer-services': <TermsOfUseForManufacturerServicesPage />,
    'data-act': <DataActServicesPage />,
  };

  useEffect(() => {
    dxfStyleFix();
  }, []);

  if (!docName) {
    return null;
  }

  if (!docPageMap[docName]) {
    return <div>Not Found: Route is not configured in this app.</div>;
  }

  return (
    <>
      {docPageMap[docName]}
      <EbdsModalSheet />
    </>
  );
};
